import PosthogService from '~/services/posthog/PosthogService';
import {
  buildNotificationPreferenceProperties,
  type INotificationSettingRecord,
  type TOfferedChannelsByEvent,
} from '~/domain/NotificationSettings';

export interface ISyncNotificationPreferencesPayload {
  settings: INotificationSettingRecord[];
  /** Channels each notification type actually offers, from `notificationTypeMap`. */
  offeredChannelsByEvent: TOfferedChannelsByEvent;
}

/**
 * Single writer for the notification-preference person properties.
 *
 * The event says a save happened; these properties say how the office is
 * configured right now, which is what cohorts and filters read. Written only
 * after a successful save, so a profile never reflects an unsaved toggle.
 */
export function syncNotificationPreferences({
  settings,
  offeredChannelsByEvent,
}: ISyncNotificationPreferencesPayload): void {
  PosthogService.getInstance().setPersonProperties(
    buildNotificationPreferenceProperties(settings, offeredChannelsByEvent),
  );
}
